export const CLOSE_OPENED_TASK_VIEW = 'CLOSE_OPENED_TASK_VIEW'
